import { PropsWithChildren, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { httpBatchLink } from "@trpc/client";
import { useStytchB2BClient } from "@stytch/react/b2b";
import { trpc } from "./index";
import { applyDeltasToInboxList } from "../contexts/inboxDeltaStore";

export function TRPCProvider({ children }: PropsWithChildren<{}>) {
  const stytch = useStytchB2BClient();

  const [queryClient] = useState(() => {
    const client = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
        },
      },
    });
    client.setQueryDefaults(getQueryKey(trpc.inbox.list), {
      structuralSharing: (_oldData, newData) => applyDeltasToInboxList(newData as never),
    });
    return client;
  });

  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: import.meta.env.VITE_TRPC_API_URL,
          maxURLLength: 7000,
          async headers() {
            return {
              authorization: stytch.session.getTokens()?.session_token,
            };
          },
        }),
      ],
    })
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
